import moment from 'moment-timezone';


export function formatPrice(number) {
    if (!number && number !== 0) return '0.00';
    const num = typeof number === 'string' ? parseFloat(number) : number;
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
}

export function formatNumberWithCommas(value) {
    if (value === null || value === undefined) return '';
    const numeric = String(value).replace(/,/g, '');
    if (numeric === '' || isNaN(Number(numeric))) return '';
    const [intPart, decimalPart] = numeric.split('.');
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
}

export function parseNumberFromFormatted(value) {
    if (value === null || value === undefined) return '';
    const numeric = String(value).replace(/,/g, '');
    if (numeric === '' || isNaN(Number(numeric))) return '';
    return numeric;
}

export function formatCurrency(number, currency = process.env.REACT_APP_CURRENCY || 'AED') {
    if (!number && number !== 0) return `${currency} 0`;
    return `${currency} ${formatPrice(number)}`;
}

export function formatDate(date, format = 'MMMM D, YYYY') {
    const timezone = process.env.REACT_APP_TIMEZONE || moment.tz.guess();
    return moment.tz(date, timezone).format(format);
}

export function formatTime(time, format = 'h:mm A') {
    if (!time) return '';
    // Accept "HH:mm", "HH:mm:ss", ISO datetimes, or full date strings
    const str = String(time);
    const m = str.match(/^(\d{1,2}):(\d{2})(:(\d{2}))?$/);
    const parsed = m
        ? moment(`${m[1].padStart(2, '0')}:${m[2]}`, 'HH:mm')
        : moment(str);
    return parsed.isValid() ? parsed.format(format) : str;
}

export function formatTimeAgo(date) {
    const timezone = process.env.REACT_APP_TIMEZONE || moment.tz.guess();
    return moment.tz(date, timezone).fromNow();
}

export function formatDateLocal(date) {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function calculateAge(date) {
    if (!date) return '';
    const timezone = process.env.REACT_APP_TIMEZONE || moment.tz.guess();
    return moment().diff(moment.tz(date, timezone), 'years');
}
